import React, { FC, PropsWithChildren } from 'react';
import { styled } from 'linaria/react';
interface SectionBgProps {
  // isResult?: boolean
  faq?: boolean;
  desktopImg: string;
  tabletImg: string;
  mobileImg: string;
}
const SectionBg: FC<PropsWithChildren<SectionBgProps>> = ({
  faq,
  desktopImg,
  tabletImg,
  mobileImg,
  children
}) => <SectionBgWrapper faq={faq as boolean} desktopImg={desktopImg} tabletImg={tabletImg} mobileImg={mobileImg}>
    {children}
  </SectionBgWrapper>;
export default SectionBg;
interface SectionBgWrapperProps {
  faq: boolean;
  desktopImg: string;
  tabletImg: string;
  mobileImg: string;
}
const _exp = /*#__PURE__*/() => ({
  desktopImg
}) => `url(${desktopImg})`;
const _exp2 = /*#__PURE__*/() => ({
  faq
}) => faq ? 'auto' : 'cover';
const _exp3 = /*#__PURE__*/() => ({
  faq
}) => faq ? 'center top' : 'center bottom';
const _exp4 = /*#__PURE__*/() => ({
  tabletImg
}) => `url(${tabletImg})`;
const _exp5 = /*#__PURE__*/() => ({
  mobileImg
}) => `url(${mobileImg})`;
const SectionBgWrapper = /*#__PURE__*/styled('div')({
  name: "SectionBgWrapper",
  class: "s4ypw28",
  propsAsIs: false,
  vars: {
    "s4ypw28-0": [_exp()],
    "s4ypw28-1": [_exp2()],
    "s4ypw28-2": [_exp3()],
    "s4ypw28-3": [_exp4()],
    "s4ypw28-4": [_exp5()]
  }
});

require("./SectionBg.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./SectionBg.tsx");